$ = require 'jquery'
ApiError = require 'app/scripts/network/api-error'
Confirm = require 'app/scripts/views/lib/confirm'
Label = require 'app/scripts/models/label'
ModelCache = require 'app/scripts/db/model-cache'
ModelLoader = require 'app/scripts/db/model-loader'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require 'react-dom'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
localizeServerError = require 'app/scripts/lib/localize-server-error'
parseTrelloUrl = require 'app/scripts/lib/util/url/parse-trello-url'
recup = require 'recup'
{ track } = require '@trello/analytics'
startDecayingInterval = require 'app/scripts/lib/util/decaying-interval'

{
  TrelloBoardAttachmentComponent
  TrelloBoardAttachmentGenericError
  TrelloBoardAttachmentLoading
  TrelloBoardAttachmentSpecificError
  TrelloBoardAttachmentUnauthorized
} = require './trello-board-attachment-components'

ReactRootComponent = require 'app/scripts/views/internal/react-root-component'

module.exports = class TrelloBoardAttachment extends View
  className: 'trello-board-attachment-container'

  initialize: ->
    @$reactRoot ?= $('<div></div>')

    @getBoard().then (board) =>
      @board = board
      if @board then @setUpListeners()
      @renderReactSection()
    .catch (e) => console.error e

  setUpListeners: ->
    if @board.id != @model.getCard().getBoard().id
      @startPolling()
      return

    renderReactSectionDebounced = @frameDebounce @renderReactSection

    @listenTo @board,
      'change': renderReactSectionDebounced
      'destroy': =>
        @board = null
        @error = 'not found'
        @renderReactSection()

    @listenTo @board.listList,
      'add remove': renderReactSectionDebounced

  startPolling: ->
    renderBoard = =>
      @fetchBoard().then =>
        @renderReactSection()

    # Limit server requests using decaying interval
    @cancelDecayingInterval = startDecayingInterval(renderBoard)

  getReactRoot: ->
    React.createElement ReactRootComponent, {}, @getTrelloBoardAttachment()

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  render: ->
    @$el.append(@$reactRoot)
    @renderReactSection()

    @

  getTrelloBoardAttachmentError: ->
    canEdit = @model.getCard().editable()

    props = {
      @error
      canEdit
      onRemove: @confirmDelete.bind(@)
    }

    recup.render => recup.div =>
      if @error == 'unauthorized'
        recup.createElement TrelloBoardAttachmentUnauthorized, props
      else if @error in ['server', 'bad request', 'not found']
        recup.createElement TrelloBoardAttachmentSpecificError, props
      else
        recup.createElement TrelloBoardAttachmentGenericError, _.extend {
          errorText: localizeServerError(@error)
        }, props

  getTrelloBoardAttachment: ->
    if @error
      return @getTrelloBoardAttachmentError()

    recup.render => recup.div =>
      if not @board
        return recup.createElement TrelloBoardAttachmentLoading

      canRemove = @model.getCard().editable()

      recup.createElement TrelloBoardAttachmentComponent, {
        @board
        canRemove
        onRemove: @confirmDelete.bind(@)
      }

  getShortLink: ->
    if not @shortLink
      @shortLink = parseTrelloUrl(@options.boardUrl).shortLink

    @shortLink

  getBoard: ->
    # Refreshing from the server as board structure gets stale

    @fetchBoard()

  fetchBoard: ->
    shortLink = @getShortLink()

    ModelLoader.loadBoardAttachment shortLink
      .then =>
        @error = null
        ModelCache.get('Board', shortLink)
      .catch ApiError.Unauthorized, (e) =>
        @error = 'unauthorized'
        null
      .catch ApiError.NotFound, (e) =>
        @error = 'not found'
        null
      .catch ApiError.Server, (e) =>
        @error = 'server'
        null
      .catch ApiError.BadRequest, (e) =>
        @error = 'bad request'
        null
      .catch (e) =>
        @error = e.message
        null

  confirmDelete: (e) ->
    Util.stop(e)

    Confirm.toggle 'remove attachment',
      elem: @$(e.currentTarget)
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.destroy()
        track("Attachment", "Delete Attachment", @model.getType())

    track("Attachment", "Attachment Thumbnail", "Confirm Delete")

  unarchiveBoard: (board, e) ->
    board.update { closed: false }, =>
      track('Board', "Reopen", "Via Trello Attachment")

  remove: ->
    @cancelDecayingInterval?()
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super

